import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import LiveSearchResultsGridRepository from '../repository/LiveSearchResultsGridRepository';
import { LiveSearchResultsGridComponent } from '../component/LiveSearchResultsGridComponent';
import LiveSearchResultsGridView from '../view/LiveSearchResultsGridView';
import liveSearchResultsGridTemplate from '../view/template';
import { LiveSearchResultsGridViewData } from '../types';

export default class LiveSearchResultsGridController extends BaseWebComponentController {
  public dataRepository: LiveSearchResultsGridRepository;
  public view: LiveSearchResultsGridView;

  constructor(public component: LiveSearchResultsGridComponent) {
    super(component);

    this.initialSetup({
      dataRepositoryConstructor: LiveSearchResultsGridRepository,
      viewConstructor: LiveSearchResultsGridView,
      viewTemplate: liveSearchResultsGridTemplate,
    });
  }

  public async getDataForView(): Promise<LiveSearchResultsGridViewData> {
    return this.dataRepository.getDataForView(this.component.getQueryExecution());
  }
}
